import { getPrices } from 'src/Libs/shop/utils/calculate-product-price'
import { Element, Product, RetrofitBatteryModalResponse, SystemConfigurationComponentsResponse } from 'src/Libs/shop/models'
import { RetrofitBattery, Component as SelectedMainComponent } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationModel'

interface PriceResult {
  price: number
  discountedPrice: number
}
/*
 * Calculates total price for selected main components (with quantity)
 */
export const getMainComponentPrices = (
  mainComponent: SystemConfigurationComponentsResponse | null,
  selectedMainComponents: SelectedMainComponent[] | null
): PriceResult => {
  let price = 0
  let discountedPrice = 0

  if (!mainComponent || selectedMainComponents === null) {
    return { price, discountedPrice }
  }

  for (const category of mainComponent.components) {
    const selectedProducts = category.products.filter(productWrapper =>
      selectedMainComponents.some(component => component.products.some(selectedProduct => selectedProduct.id === productWrapper.product.id))
    )

    for (const selected of selectedProducts) {
      const selectedProduct = selectedMainComponents
        .flatMap(component => component.products)
        .find(selectedProduct => selectedProduct.id === selected.product.id)

      if (selectedProduct) {
        const prices = getPrices(selected.product)
        const quantity = selectedProduct.qty || 1

        price += prices.price * quantity
        discountedPrice += prices.discountedPrice * quantity
      }
    }
  }

  return { price, discountedPrice }
}

/*
 * Calculates total price for selected power meters
 */
export const getPowerMeterPrices = (selectedPowerMeters: Element[] | undefined): PriceResult => {
  let price = 0
  let discountedPrice = 0

  for (const element of selectedPowerMeters ?? []) {
    const prices = getPrices(element)

    price += prices.price
    discountedPrice += prices.discountedPrice
  }

  return { price, discountedPrice }
}
/*
 * Calculates price for selected smart meter
 */
export const getSmartMeterPrices = (selectedSmartMeter: Product | undefined): PriceResult => {
  return getPrices(selectedSmartMeter)
}

/*
 * Calculates total price for selected battery with quantity
 */
export const getBatteryPrices = (selectedBattery: RetrofitBatteryModalResponse | null, retrofitBattery: RetrofitBattery | null): PriceResult => {
  if (!selectedBattery || !retrofitBattery) {
    return { price: 0, discountedPrice: 0 }
  }

  const prices = getPrices(selectedBattery.product)
  const quantity = retrofitBattery.qty

  return {
    price: prices.price * quantity,
    discountedPrice: prices.discountedPrice * quantity,
  }
}

/*
 * Calculates price for EM360 product if exists
 */
export const getEm360Prices = (mainComponent: SystemConfigurationComponentsResponse | null): PriceResult => {
  if (!mainComponent?.em360Product) {
    return { price: 0, discountedPrice: 0 }
  }

  return getPrices(mainComponent.em360Product)
}

/*
 * Calculates price for selected warranty extension
 */
export const getWarrantyExtensionPrices = (
  mainComponent: SystemConfigurationComponentsResponse | null,
  selectedWarrantyExtensionId?: string | null
): PriceResult => {
  if (!selectedWarrantyExtensionId || !mainComponent?.warrantyExtensions) {
    return { price: 0, discountedPrice: 0 }
  }

  const selectedWarranty = mainComponent.warrantyExtensions.find(product => product.id === selectedWarrantyExtensionId)

  return getPrices(selectedWarranty)
}
